import { useGridApiRef } from "@mui/x-data-grid-pro";
// import data from "./tableData.json";
import {
  get_schedule_table_headers,
} from "./customCols";
import { useEffect, useState } from "react";
import { get_analyst_list } from "../../../util";
import ReportingDialog from "../../Output/components/ReportingDialog";
import { Box, Input, MenuItem, Select, Stack } from "@mui/material";
import { v4 } from "uuid";
import HomePageTimeDatePicker from "../../HomePage/components/HomePageTimeDatePicker";
import axiosInstance from "../../../http-common";
import ContainedButton from "../../../common/components/Buttons/ContainedButton";
import { CustomDataGrid } from "../../../common/components/Table/CustomDataGrid";
import { sample_types as old_sample_types } from "../../HomePage/components/PoTable/helper/po_columns";
import { get_material_types_list } from "../../Output/utils/helpers";

const postNewScheduleItem = async (sample_status_data) => {
  console.log(sample_status_data);
  const dd_qcrd = sample_status_data.qc_receive_date.getDate();
  const mm_qcrd = sample_status_data.qc_receive_date.getMonth();
  const yyyy_qcrd = sample_status_data.qc_receive_date.getFullYear();
  const hh_qcrd = sample_status_data.qc_receive_date.getHours();
  const min_qcrd = sample_status_data.qc_receive_date.getMinutes();
  const ss_qcrd = sample_status_data.qc_receive_date.getSeconds();

  const d_qcrd = `${yyyy_qcrd}-${mm_qcrd + 1
    }-${dd_qcrd} ${hh_qcrd}:${min_qcrd}:${ss_qcrd}`;
  sample_status_data.qc_receive_date = d_qcrd;

  const dd_pst = sample_status_data.pre_start_time.getDate();
  const mm_pst = sample_status_data.pre_start_time.getMonth();
  const yyyy_pst = sample_status_data.pre_start_time.getFullYear();
  const hh_pst = sample_status_data.pre_start_time.getHours();
  const min_pst = sample_status_data.pre_start_time.getMinutes();
  const ss_pst = sample_status_data.pre_start_time.getSeconds();

  const d_pst = `${yyyy_pst}-${mm_pst + 1
    }-${dd_pst} ${hh_pst}:${min_pst}:${ss_pst}`;
  sample_status_data.analyst_start_time = d_pst;

  const dd_pet = sample_status_data.pre_end_time.getDate();
  const mm_pet = sample_status_data.pre_end_time.getMonth();
  const yyyy_pet = sample_status_data.pre_end_time.getFullYear();
  const hh_pet = sample_status_data.pre_end_time.getHours();
  const min_pet = sample_status_data.pre_end_time.getMinutes();
  const ss_pet = sample_status_data.pre_end_time.getSeconds();

  const d_pet = `${yyyy_pet}-${mm_pet + 1
    }-${dd_pet} ${hh_pet}:${min_pet}:${ss_pet}`;
  sample_status_data.analyst_end_time = d_pet;
  delete sample_status_data.pre_start_time;
  delete sample_status_data.pre_end_time;

  const dd_mst = sample_status_data.machine_start_time.getDate();
  const mm_mst = sample_status_data.machine_start_time.getMonth();
  const yyyy_mst = sample_status_data.machine_start_time.getFullYear();
  const hh_mst = sample_status_data.machine_start_time.getHours();
  const min_mst = sample_status_data.machine_start_time.getMinutes();
  const ss_mst = sample_status_data.machine_start_time.getSeconds();

  const d_mst = `${yyyy_mst}-${mm_mst + 1
    }-${dd_mst} ${hh_mst}:${min_mst}:${ss_mst}`;
  delete sample_status_data.machine_start_time;
  sample_status_data.machine_start_time = d_mst;

  const dd_met = sample_status_data.machine_end_time.getDate();
  const mm_met = sample_status_data.machine_end_time.getMonth();
  const yyyy_met = sample_status_data.machine_end_time.getFullYear();
  const hh_met = sample_status_data.machine_end_time.getHours();
  const min_met = sample_status_data.machine_end_time.getMinutes();
  const ss_met = sample_status_data.machine_end_time.getSeconds();

  const d_met = `${yyyy_met}-${mm_met + 1
    }-${dd_met} ${hh_met}:${min_met}:${ss_met}`;
  delete sample_status_data.machine_end_time;
  sample_status_data.machine_end_time = d_met;

  // return {
  //   status: "success"
  // };
  const id = sample_status_data.id;
  delete sample_status_data?.id;
  const data = JSON.stringify({ ...sample_status_data, role: "analyst" });
  try {
    const response = await axiosInstance.post(`/v1/qc/edit_qc_schedule/`, data);
    const result = response.data;
    if (result?.status === "success") {
      alert("Added Schedule Successfully!");
      sample_status_data.id = id;
      return true;
    } else throw new Error(`${result.message}`);
  } catch (error) {
    console.log({ error });
    return error;
    // return ;
  }
};

const ScheduleFieldCell = ({
  value,
  id,
  handle_change,
  type = "text",
  options = [],
}) => {
  if (type === "select") {
    return (
      <Box className="w-full">
        <Select
          sx={{ width: "100%" }}
          value={value}
          id={id}
          onChange={handle_change}
          name={id}
          size={"small"}
        >
          <MenuItem value="" disabled key={"nothing_in_schedule_material_type"}>
            Select Material Type
          </MenuItem>
          {options?.map((item, idx) => (
            <MenuItem key={`${item.label}-${idx}`} value={item?.value}>
              {item?.label}
            </MenuItem>
          ))}
        </Select>
      </Box>
    );
  }
  return (
    <Input
      // sx={{ width: "100%" }}
      value={value}
      id={id}
      name={id}
      onChange={(e) => {
        handle_change(e);
      }}
      onKeyDown={(e) => {
        e.stopPropagation();
      }}
      type={type}
    />
  );
};

const Table = ({ hidden_fields = [], ...props }) => {
  console.log(hidden_fields);
  const gridApi = useGridApiRef();
  const data = props?.data;
  const rows = [];
  // console.log({ keys });
  const schedule_table_headers =
    get_schedule_table_headers && get_schedule_table_headers(props?.aria_label);
  const [columns, set_columns] = useState(
    Object.values(schedule_table_headers)
  );

  console.log(columns);
  const getRowClassName = (params) => {
    if (params.row.approve === false && props?.aria_label === "today_table") {
      return "bg-yellow-200"; // Apply this class for completed rows
    }
    return "";
  };
  // console.log(columns);

  for (let j = 0; j < data.length; j++) {
    // const obj = { id: j + 1 };
    // const values = Object.values(data[j]);
    // console.log({ values, keys });
    // for (let i = 0; i < keys.length; i++) {
    //   obj[keys[i]] = values[i];
    // }
    // rows.push(obj);
    const obj = {
      id: data[j]?._id || j + 1,
      ...data[j],
    };
    rows.push(obj);
  }
  console.log(data);
  useEffect(() => {
    get_analyst_list().then((data) => {
      let temp = [...columns].map((item) => {
        if (item.field === "analyst_id") {
          return {
            ...item,
            type: "singleSelect",
            valueOptions: data.map((analyst_data) => ({
              label: analyst_data.analyst_id,
              value: analyst_data.analyst_id,
            })),
            // editable: true
          };
        }
        return item;
      });
      set_columns(temp);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [open, set_open] = useState(false);

  const handleClose = () => {
    set_open(false);
  };

  const [selected_row, set_selected_row] = useState({});

  gridApi.current.set_selected_row = set_selected_row;

  useEffect(() => {
    console.log({ selected_row });
    if (Object.keys(selected_row).length > 0) {
      set_open(true);
    }
  }, [selected_row]);

  const [new_dg_row, set_new_dg_row] = useState([
    {
      id: v4(),
      product_code: "",
      product_name: "",
      batch_number: "",
      qc_receive_date: new Date(),
      market: "",
      material_type: "",
      spec_id: "",
      stp_id: "",
      test_name: "",
      non_critical_machines: "",
      pre_start_time: new Date(),
      pre_end_time: new Date(),
      analyst_id: "",
      machine_id: "",
      machine_start_time: new Date(),
      machine_end_time: new Date(),
    },
  ]);

  const handle_change_new_row_data = (e) => {
    const { id, value, name } = e.target;
    // console.log({ id, value, e, name });
    const old = { ...new_dg_row[0] };
    old[id || name] = value;
    set_new_dg_row([{ ...old }]);
  };

  const [sample_types, set_sample_types] = useState([...old_sample_types]);

  const initialise_sample_types = async () => {
    const names_list = await get_material_types_list();
    if (names_list) {
      const sample_types_arr = names_list?.map((name) => ({
        value: name,
        label: name,
      }));
      set_sample_types(sample_types_arr);
    }
  };

  useEffect(() => {
    initialise_sample_types();
  }, []);

  const new_dg_columns = [
    // {
    //   headerClassName: "bg-blue-200",
    //   field: "_id",
    //   headerName: "ID",
    //   visible: false,
    //   width: 100,
    // },
    {
      headerClassName: "bg-blue-200",
      field: "product_code",
      headerName: "Product Code",
      visible: true,
      editable: false,
      width: 150,
      renderCell: (props) => {
        return (
          <ScheduleFieldCell
            {...props}
            value={new_dg_row[0]["product_code"]}
            handle_change={handle_change_new_row_data}
            id={"product_code"}
          />
        );
      },
    },
    {
      headerClassName: "bg-blue-200",
      field: "product_name",
      headerName: "Product Name",
      visible: true,
      editable: false,
      width: 150,
      renderCell: (props) => {
        return (
          <ScheduleFieldCell
            {...props}
            value={new_dg_row[0]["product_name"]}
            handle_change={handle_change_new_row_data}
            id={"product_name"}
          />
        );
      },
    },
    {
      headerClassName: "bg-blue-200",
      field: "batch_number",
      headerName: "BATCH ID",
      visible: true,
      editable: false,
      width: 100,
      renderCell: (props) => {
        return (
          <ScheduleFieldCell
            {...props}
            value={new_dg_row[0]["batch_number"]}
            handle_change={handle_change_new_row_data}
            id={"batch_number"}
          />
        );
      },
    },
    {
      headerClassName: "bg-blue-200",
      field: "test_name",
      headerName: "TEST NAME",
      visible: true,
      editable: false,
      width: 150,
      renderCell: (props) => {
        return (
          <ScheduleFieldCell
            {...props}
            value={new_dg_row[0]["test_name"]}
            handle_change={handle_change_new_row_data}
            id={"test_name"}
          />
        );
      },
    },
    {
      headerClassName: "bg-blue-200",
      field: "spec_id",
      headerName: "SPEC ID",
      visible: true,
      editable: false,
      width: 150,
      renderCell: (props) => {
        return (
          <ScheduleFieldCell
            {...props}
            value={new_dg_row[0]["spec_id"]}
            handle_change={handle_change_new_row_data}
            id={"spec_id"}
          />
        );
      },
      // type: "singleSelect",
      // valueOptions: [
      //   { label: "FS015148", value: "FS015148" },
      //   { label: "FS007772", value: "FS007772" },
      //   { label: "FS007940", value: "FS007940" },
      //   { label: "FS011879", value: "FS011879" },
      //   { label: "FS012696", value: "FS012696" },
      //   { label: "FS017600", value: "FS017600" },
      //   { label: "FS015148", value: "FS015148" },
      //   { label: "FS007940", value: "FS007940" },
      //   { label: "FS007772", value: "FS007772" },
      //   { label: "FS011879", value: "FS011879" },
      //   { label: "FS012696", value: "FS012696" },
      //   { label: "FS017600", value: "FS017600" },
      // ]
    },
    {
      headerClassName: "bg-blue-200",
      field: "qc_receive_date",
      headerName: "QC RECEIVE DATE",
      visible: true,
      editable: false,
      width: 210,
      type: "dateTime",
      renderCell: (props) => {
        return (
          <HomePageTimeDatePicker {...props} state_setter={set_new_dg_row} />
        );
      },
    },
    {
      headerClassName: "bg-blue-200",
      field: "market",
      headerName: "MARKET",
      visible: true,
      editable: false,
      width: 150,
      renderCell: (props) => {
        return (
          <ScheduleFieldCell
            {...props}
            value={new_dg_row[0]["market"]}
            handle_change={handle_change_new_row_data}
            id={"market"}
          />
        );
      },
    },
    {
      headerClassName: "bg-blue-200",
      field: "material_type",
      headerName: "MATERIAL TYPE",
      visible: true,
      editable: false,
      width: 200,
      type: "singleSelect",
      valueOptions: [...sample_types],
      renderCell: (props) => {
        return (
          <ScheduleFieldCell
            {...props}
            value={new_dg_row[0]["material_type"]}
            handle_change={handle_change_new_row_data}
            id={"material_type"}
            type={"select"}
            options={[...sample_types]}
          />
        );
      },
    },
    {
      headerClassName: "bg-blue-200",
      field: "pre_start_time",
      headerName: "ANALYST START TIME",
      visible: true,
      width: 210,
      type: "dateTime",
      editable: false,
      valueGetter: ({ value }) => {
        return new Date(value);
      },
      renderCell: (props) => {
        return (
          <HomePageTimeDatePicker {...props} state_setter={set_new_dg_row} />
        );
      },
    },
    {
      headerClassName: "bg-blue-200",
      field: "pre_end_time",
      headerName: "ANALYST END TIME",
      visible: true,
      width: 210,
      type: "dateTime",
      editable: false,
      valueGetter: ({ value }) => {
        return new Date(value);
      },
      renderCell: (props) => {
        return (
          <HomePageTimeDatePicker {...props} state_setter={set_new_dg_row} />
        );
      },
    },
    {
      headerClassName: "bg-blue-200",
      field: "machine_start_time",
      headerName: "MACHINE START TIME",
      visible: true,
      width: 210,
      type: "dateTime",
      editable: false,
      valueGetter: ({ value }) => {
        return new Date(value);
      },
      renderCell: (props) => {
        return (
          <HomePageTimeDatePicker {...props} state_setter={set_new_dg_row} />
        );
      },
    },

    {
      headerClassName: "bg-blue-200",
      field: "machine_end_time",
      headerName: "MACHINE END TIME",
      visible: true,
      width: 210,
      type: "dateTime",
      editable: false,
      valueGetter: ({ value }) => {
        return new Date(value);
      },
      renderCell: (props) => {
        return (
          <HomePageTimeDatePicker {...props} state_setter={set_new_dg_row} />
        );
      },
    },

    // {
    //   headerClassName: "bg-blue-200",
    //   field: "stp_id",
    //   headerName: "STP ID",
    //   visible: false,
    //   editable: false,
    //   width: 150,
    //   renderCell: (props) => {
    //     return (
    //       <ScheduleFieldCell
    //         {...props}
    //         value={new_dg_row[0]["stp_id"]}
    //         handle_change={handle_change_new_row_data}
    //         id={"stp_id"}
    //       />
    //     );
    //   },
    //   // type: "singleSelect",
    //   // valueOptions: [
    //   //   { label: "FT007296", value: "FT007296" },
    //   //   { label: "FT003572", value: "FT003572" },
    //   //   { label: "FT003702", value: "FT003702" },
    //   //   { label: "FT005640", value: "FT005640" },
    //   //   { label: "FT010562", value: "FT010562" },
    //   //   { label: "FT006061", value: "FT006061" },
    //   //   { label: "FT008844", value: "FT008844" },
    //   //   { label: "FT010888", value: "FT010888" },
    //   // ]
    // },

    // "step_name": {
    //   field: "step_name",
    //   headerName: "STEP NAME",
    //   visible: true,
    //   editable: false,
    //   width: 250,
    // },
    {
      headerClassName: "bg-blue-200",
      field: "analyst_id",
      headerName: "ANALYST ID",
      visible: true,
      editable: false,
      width: 200,
      renderCell: (props) => {
        return (
          <ScheduleFieldCell
            {...props}
            value={new_dg_row[0]["analyst_id"]}
            handle_change={handle_change_new_row_data}
            id={"analyst_id"}
          />
        );
      },
      // renderCell: (props) => <AnalystDropdown {...props} />,
    },
    {
      headerClassName: "bg-blue-200",
      field: "machine_id",
      headerName: "MACHINE ID",
      visible: true,
      editable: false,
      width: 100,
      renderCell: (props) => {
        return (
          <ScheduleFieldCell
            {...props}
            value={new_dg_row[0]["machine_id"]}
            handle_change={handle_change_new_row_data}
            id={"machine_id"}
          />
        );
      },
      // renderCell: (props) => <MachineDropdown {...props} />,
      // type: "singleSelect",
      // valueOptions: [...machine_list]
    },
    {
      headerClassName: "bg-blue-200",
      field: "non_critical_machines",
      headerName: "NON CRITICAL MACHINES",
      visible: true,
      editable: false,
      width: 200,
      renderCell: (props) => {
        return (
          <ScheduleFieldCell
            {...props}
            value={new_dg_row[0]["non_critical_machines"]}
            handle_change={handle_change_new_row_data}
            id={"non_critical_machines"}
          />
        );
      },
      // renderCell: (props) => <NonCriticalMachines {...props} />,
      // type: "singleSelect",
      // valueOptions: [...machine_list]
    },

    {
      field: "add_row",
      headerName: "",
      editable: false,
      renderCell: () => {
        const handle_add = async () => {
          const row = new_dg_row[0];
          const { stp_id, ...rowWithoutStpId } = row; // to exclude stp_id
          const vals = Object.values(rowWithoutStpId);
          // const vals = Object.values(row);
          for (let val of vals) {
            if (val === "" || val === null) {
              console.log({ val, row });
              alert(
                "Please enter all the fields before adding the Sample Status."
              );
              return;
            }
          }

          const response = await postNewScheduleItem({ ...row });
          if (response === true) {
            gridApi.current.updateRows([{ ...row }]);
            set_new_dg_row((prev) => [
              {
                ...prev[0],
                product_code: "",
                product_name: "",
                batch_number: "",
                qc_receive_date: new Date(),
                market: "",
                material_type: "",
                spec_id: "",
                stp_id: "",
                test_name: "",
                non_critical_machines: "",
                pre_start_time: new Date(),
                pre_end_time: new Date(),
                analyst_id: "",
                machine_id: "",
                machine_start_time: new Date(),
                machine_end_time: new Date(),
                id: v4(),
              },
            ]);
            // alert("updated");
          } else {
            // alert("couldn't update due to some error at the backend.");
            alert(response);
          }
        };
        return <ContainedButton handleClick={handle_add}>Add</ContainedButton>;
      },
    },
  ];
  console.log(hidden_fields);
  return (
    <div>
      <div
        style={{ height: 250, width: "100%" }}
        className="bg-white rounded-xl shadwo-xl mt-2"
      >
        {gridApi?.current?.selectedRow && (
          <div>
            <ReportingDialog
              gridApiRef={gridApi}
              handleClose={handleClose}
              open={open}
              selected_row={selected_row}
            />
          </div>
        )}
        <CustomDataGrid
          aria-label={props?.aria_label}
          rows={rows}
          columns={columns}
          hideFooter
          initialState={props?.initialState}
          columnVisibilityModel={{
            id: false,
            _id: false,
            // stp_id: false,
            ...hidden_fields?.reduce(
              (acc, el) => ({
                ...acc,
                [el]: false,
              }),
              {}
            ),
          }}
          getRowClassName={getRowClassName}
          apiRef={gridApi}
          slots={{
            noRowsOverlay: () => (
              <Stack height="100%" alignItems="center" justifyContent="center">
                No rows in Schedule
              </Stack>
            ),
          }}
        />
      </div>
      {props?.has_new_schedule_row && (
        <div>
          <Box>
            <h2 className="text-lg font-bold text-[#084298] p-3">
              Add a New Task
            </h2>
            <CustomDataGrid
              columns={new_dg_columns}
              rows={new_dg_row}
              ccolumnVisibilityModel={{
                id: false,
                _id: false,
                // stp_id: false,
                ...hidden_fields?.reduce(
                  (acc, el) => ({
                    ...acc,
                    [el]: false,
                  }),
                  {}
                ),
              }}
              initialState={{
                pinnedColumns: {
                  left: ["batch_number", "product_name"],
                  right: [
                    "analyst_id",
                    "machine_id",
                    "start_time",
                    "end_time",
                    "add_row",
                  ],
                },
              }}
              hideFooter
            />
          </Box>
        </div>
      )}
    </div>
  );
};

export default Table;
